<template>
    <div class="">
        <drawer 
            :title="addEditTitle" 
            :dialogShow="addEditShow" 
            @handleChange="handleChangeDrawer"
        >
            <div slot="body">
              <div class="totals-box pl24 mt20">
                <div class="flex-row mb30">
                  <div class="itemName">客户姓名</div>
                  <div class="itemNum jishi">{{ form.customerName }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">手机号码</div>
                  <div class="itemNum">{{ form.mobile }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">性别</div>
                  <div class="itemNum">{{ form.gender == 'male' ? '男' : '女' }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">卡号</div>
                  <div class="itemNum">{{ form.docNo }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">分类</div>
                  <div class="itemNum">{{ form.categoryName }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">部位及症状</div>
                  <div class="itemNum">{{ form.symptom }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">下次登记时间</div>
                  <div class="itemNum">{{ form.nextRepairTime }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">开卡日期</div>
                  <div class="itemNum">{{ form.recordTime }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">技师名称</div>
                  <div class="itemNum">{{ form.staffIdCn }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">备注</div>
                  <div class="itemNum">{{ form.remark }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">登记照片</div>
                  <div class="itemNum">
                    <div class="img-list" v-if="imgUrl.length">
                          <el-image
                            class="img"
                            v-for="(i,j) in imgUrl"
                            :key="j"
                            :src="i"
                            title="点击放大图片"
                            :preview-src-list="previewList"
                            @click="handPreview(i)"
                          ></el-image>
                        </div>
                  </div>
                </div>
              </div>

                <!-- <div class="repair-box">
                    <div class="repair-msg">    
                        <div class="center-mains">
                            <div class="imgs">
                                <p class="imgs-name">修护照片</p>
                                <div class="img-list" v-if="imgUrl.length != 0">
                                    <el-image class="img" v-for="(i,j) in imgUrl" :key="j" :src="i" title="点击放大图片" :preview-src-list="imgUrl"></el-image>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div> -->
                <div class="drawer-footer">
                  <div class="btns">
                      <el-button @click="handleChangeDrawer">返回</el-button>
                  </div>
                </div>
            </div>
        </drawer>
    </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
export default {
    mixins: [minxin],
    components:{drawer},
    data () {
        return {
            addEditTitle: '',
            addEditShow: false,
            form: {
                mobile: '',
                gender: 'male',
                nextRepairTime: '',
                recordTime: '',
            },
            columns: [],
            staffList:[],
            cardOldName: '',
            showPicker: false,
            imgUrl: [],
            previewList: []
        }
    },
    created(){
        this.editInit();
    },
    methods: {
        editInit(){
            this.$on('set',function(org){
                Object.assign(this.$data,this.$options.data());
                this.addEditTitle = '纸质修护卡详情';
                this.$api.get(this.$url.paperRepairDocument.get,{
                    id: org.id
                }).then( res => {
                    if(res){
                        this.form = res;
                        console.log(res)
                        this.imgUrl = res.recordList[0].imgUrlList 
                        this.form.nextRepairTime = this.formatDay(this.form.nextRepairTime);
                        this.form.recordTime = this.formatDay(this.form.recordTime);
                        this.cardOldList();
                    }
                }).catch(error => {
    
                })
                this.addEditShow = true;
            })
            
        },
        handleChangeDrawer(){
            this.addEditShow = false;
            this.$emit('change',false);
        },
        onSubmit(values){
            this.addEditShow = false;
        },
        handPreview (url) {
          let imgUrl = []
          this.previewList = []
          if (url.indexOf("?") > -1) {
            let arr = url.split("?")
            imgUrl.push(arr[0])
          } else {
            imgUrl.push(url)
          }
          this.previewList = imgUrl
          console.log(this.previewList);
        },
    }
}
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.img {
  border-radius: 5px;
  margin: 0 10px 10px 0;
  width: 80px;
  height: 80px;
}
</style>